import React, { useState } from 'react';
import {careerMeta} from "../constants/meta";
import Meta from "../components/common/Helmet";
import {useTranslation} from "react-i18next";
import {timeAgo} from "../constants/dateTime";

export default function Careers() {
  const {t} = useTranslation()
  const jobList = [
    {
      title: t('common.itProjectManager'),
      company: t('common.mesoftBusineessSolution'),
      time: timeAgo(new Date().toISOString()), // ISO 8601 format
      logoBg: 'bg-theme-color',
      logoText: t('common.ms'),
      isActive: true,
      detail: {
        type: 'Full-time',
        employees: '10 - 50 employees',
        website: 'mesoft.ae',
        description: `We are looking for a talented and motivated creative director to lead our company’s creative department. The successful candidate must possess excellent leadership qualities, with the ability to maximize the talents of their team.`,
        responsibilities: [
          'Bachelor\'s degree in a related field of study.',
          'At least 2 Years of Experience',
          'Strong knowledge of Application and Web Development.',
          'Exceptional verbal, written, and presentation skills.',
          'Fluency in English.',
          'Ability to work effectively both independently and as part of a team.',
          'Experience using computers for a variety of tasks.',
          'Competency in Microsoft applications including Word, Excel, and Outlook.',
          'Knowledge of file management, transcription, and other administrative procedures.',
          'Ability to work on tight deadlines.\n',
        ],
      },
    },
    {
      title: t('common.businessDevelopment'),
      company: t('common.mesoftBusineessSolution'),
      time: timeAgo(new Date().toISOString()), // ISO 8601 format
      logoBg: 'bg-theme-color',
      logoText: t('common.ms'),
      isActive: true,
      detail: {
        type: 'Full-time',
        employees: '10 - 50 employees',
        website: 'mesoft.ae',
        description: `We are looking for a talented and motivated creative director to lead our company’s creative department. The successful candidate must possess excellent leadership qualities, with the ability to maximize the talents of their team.`,
        responsibilities: [
          'Bachelor\'s degree in a related field of study',
          'At least 2 years of UAE experience in IT services',
          'Proficiency in English',
          'Excellent communications and presentation skills',
          'Excellent understanding of IT delivery models, pricing models & proficiency with technologies',
          'Preferable – understanding of Board Meetings / Visitor Management / IT security solutions.',
          'Good analytical & research skills - Ability to draw meaningful insights and inferences to build business plan',
          'Lead customer meetings/interactions',
        ],
      },
    },
  ];

  const [selectedJob, setSelectedJob] = useState(jobList[0]);
  return (
    <div>
      <Meta
        title={careerMeta.title}
        description={careerMeta.description}
        canonical={careerMeta.canonical}
        keywords={careerMeta.keywords}
        ogTitle={careerMeta.title}
        ogDescription={careerMeta.description}
      />
      <div className="min-h-screen">
        <div className="relative career-page-cover-photo lg:py-32">
          {/* Overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

          {/* Content */}
          <div className="relative z-3 md:w-theme-container w-mobile-container mx-auto">
            <div className="p-8 rounded-lg text-center mb-8 bg-yellow-3000">
              <div className="md:text-4xl text-base flex items-center justify-center text-center text-white font-semibold">
                {t('common.findYour')} <span className="text-theme-color [text-shadow:_-0.7px_-0.7px_0_white,_0.7px_-0.7px_0_white,_-0.7px_0.7px_0_white,_0.7px_0.7px_0_white] mx-2 ">{t('common.dreamJob')} </span> {t('common.now')}
              </div>
              <div className="mt-6 flex flex-wrap gap-4 justify-center hidden ">
                <input
                  type="text"
                  placeholder={t('common.careerInputPlaceholder')}
                  className="border w-[80%] py-2 rounded pl-5"
                />
                <button className="bg-theme-color text-white px-6 py-1 rounded">{t('common.search')}</button>
              </div>
            </div>
          </div>
        </div>


        <div className="md:w-theme-container w-mobile-container mx-auto">
          <div className="grid md:grid-cols-[360px_1fr] lg:grid-cols-[360px_1fr] grid-cols-1 gap-4 mt-12">
            {/* Sidebar - Job List */}
            <div className="w-1/3gdfg space-y-4">
              {jobList.map((job, index) => (
                <div
                  key={index}
                  className={`flex items-center justify-between p-4 border rounded-lg cursor-pointer ${
                    selectedJob.title === job.title ? 'border-theme-color shadow' : 'hover:shadow'
                  }`}
                  onClick={() => setSelectedJob(job)}
                >
                  <div className="flex items-center gap-4 ">
                    <div className={`w-12 h-12 flex items-center justify-center text-white text-xl rounded ${job.logoBg}`}>
                      {job.logoText}
                    </div>
                    <div>
                      <h3 className="text-blue-600">{job.title}</h3>
                      <p className="text-sm text-gray-500">{job.company}</p>
                    </div>
                  </div>
                  <div className="text-sm text-gray-400">{job.time}</div>
                </div>
              ))}
            </div>

            {/* Main Content - Job Details */}
            <div className="w-2/3gdf bg-white p-6 rounded-lg shadow">
              <h2 className="text-2xl text-blue-700">{selectedJob.title}</h2>
              <p className="text-gray-700">{selectedJob.company}</p>
              <div className="flex flex-wrap items-center gap-6 text-sm text-gray-500 mt-2">
                <span>📄 {selectedJob.detail?.type}</span>
                <span>👥 {selectedJob.detail?.employees}</span>
                <a href={`https://${selectedJob.detail?.website}`} className="text-blue-600 hover:underline">
                  {selectedJob.detail?.website}
                </a>
              </div>

              <div className="mt-4 flex gap-4">
                <a
                  href={`mailto:info@mesoft.ae?subject=${selectedJob.title}`}
                  className="bg-pink-500 text-white px-4 py-2 rounded">{t('common.applyNow')}</a>
                {/*<button className="border border-pink-500 text-pink-500 px-4 py-2 rounded">Save</button>*/}
              </div>

              <p className="mt-6 text-gray-700 whitespace-pre-line">{selectedJob.detail?.description}</p>

              {selectedJob.detail?.responsibilities && (
                <div className="mt-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Responsibilities:</h3>
                  <ul className="list-disc list-inside text-gray-700 space-y-1">
                    {selectedJob.detail.responsibilities.map((resp, idx) => (
                      <li key={idx}>{resp}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
